var render, staticRenderFns
import script from "./retrieval.vue?vue&type=script&lang=js&"
export * from "./retrieval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187a09a5",
  null
  
)

export default component.exports